require('jquery-ui/ui/widget');

require('jquery-ui/ui/data');

require('jquery-ui/ui/scroll-parent');

require('jquery-ui/ui/widgets/sortable');

require('jquery-ui/ui/widgets/mouse');

require('jquery-ui/themes/base/core.css');

require('jquery-ui/themes/base/sortable.css');